import { useEntriesV2Cache } from "@/shared/cache";
import type { Entry } from "./normalize";

/**
 * Thin adapter around the v2 entries cache so the view keeps its existing
 * `{ data, isLoading }` contract. The cache returns `EntryV2[]` which is the
 * same shape as `Entry` (re-exported from `./normalize`).
 */
export function useAllEntries(): { data: Entry[]; isLoading: boolean } {
	const { entries, isLoading } = useEntriesV2Cache();
	return { data: entries, isLoading };
}
